import React from 'react'

import EditUserModal from './EditUserModal'

const EditUserPage = props => {
  return <EditUserModal noOverlay onClose={false} {...props} />
}

export default EditUserPage
